module.exports = __webpack_public_path__ + "img/bg1.80362993.png";